import { Component, effect, inject } from '@angular/core';
import { TableColumn, TableColumnType } from '../../../../modules/shared/components/kit/table/table.types';
import { routeParams, translate } from '../../../../modules/shared/shared.global-service';
import { TranslatePipe } from '@ngx-translate/core';
import { FilterBuilder } from '../../../../modules/content/helper/filter.builder';
import { OrganizationSettingsProjectStore } from './organization-settings-project.store';
import { ProjectObject } from '@libs/types/src/mado/object-type/organization';
import { projectFrag } from './organization-settings-project.query';
import { OrganizationSettingsProjectDialogComponent } from './dialog/organization-settings-project-dialog.component';
import { BaseDialogService } from '../../../kit/base-dialog/base-dialog-service';
import { TableComponent } from 'packages/client/src/app/modules/shared/components/kit/table/table.component';

@Component({
    selector: 'app-organization-settings-project',
    templateUrl: './organization-settings-project.component.html',
    providers: [OrganizationSettingsProjectStore],
    imports: [
        TranslatePipe,
        TableComponent,
    ],
})
export class OrganizationSettingsProjectComponent {
    protected readonly store = inject(OrganizationSettingsProjectStore);
    protected readonly dialogService = inject(BaseDialogService);

    protected readonly prefix = 'organization-settings.mado.project.';

    protected columns: TableColumn[] = [
        {
            name: 'name',
        },
        {
            name: 'code',
        },
        {
            name: 'description',
        },
        {
            name: 'dateFrom',
            type: TableColumnType.Date,
            filterable: false,
        },
        {
            name: 'dateTo',
            type: TableColumnType.Date,
            filterable: false,
        },
    ];

    constructor() {
        effect(() => {
            this.loadProjects();
        });
    }

    openDialog(project: ProjectObject | null = null) {
        const header = `${this.prefix}title` + (project ? 'Detail' : 'Create');
        const dialog = this.dialogService.open(
            OrganizationSettingsProjectDialogComponent,
            {
                header: translate.instant(header),
                data: { project },
            },
        );

        dialog?.onClose.subscribe((it) => {
            if (it === true) {
                this.loadProjects();
            }
        });
    }

    async loadProjects() {
        const organizationId = routeParams.organizationId();

        await this.store.api.getProjects(FilterBuilder.singlePage({ organizationId }), projectFrag);
    }
}
